import { ClientService, ToastMessageService } from '@fitness-force/api';

import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  input,
  output,
  inject,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { RippleModule } from 'primeng/ripple';
import { BehaviorSubject } from 'rxjs';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';

@Component({
  selector: 'unblock-client-booking',
  templateUrl: './unblock-client-booking.component.html',
  styleUrls: ['./unblock-client-booking.component.scss'],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DialogModule,
    AvatarModule,
    ButtonModule,
    RippleModule,
    ShortNamePipe,
    TranslateModule,
  ],
})
export class UnblockClientBookingComponent implements OnInit {
  translate = inject(TranslateService);
  private clientService = inject(ClientService);
  private toastMessageService = inject(ToastMessageService);
  private cd = inject(ChangeDetectorRef);

  readonly unblockClientBookingModal = input<boolean | null>(false);
  readonly clientData$ = input<any>(new BehaviorSubject(null));
  readonly closeUnblockClientBookingDialog = output<{
    close: boolean;
    action: string | null;
  }>();

  allClientData: any;
  btnLoading: boolean = false;

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    const clientDataSubject = this.clientData$();
    if (clientDataSubject) {
      clientDataSubject.subscribe((client: any) => {
        this.allClientData = client;
      });
    }
  }

  closeDialogEvent(action: string | null = null) {
    this.closeUnblockClientBookingDialog.emit({ close: true, action });
  }

  unblockClientBooking() {
    this.btnLoading = true;

    const patchRequest = [
      {
        op: 'replace',
        path: '/OnlineBookingStoppedUntil',
        value: null,
      },
    ];

    let tenantId = 0;
    if (
      this.allClientData.home_club_tenant_id &&
      this.allClientData.home_club_tenant_id > 0
    ) {
      tenantId = this.allClientData.home_club_tenant_id;
    } else {
      tenantId = this.allClientData.createdin_tenant_id;
    }

    this.clientService
      .patchClient(this.allClientData.id, tenantId, patchRequest)
      .subscribe({
        next: (res: any) => {
          this.translate
            .get('CLIENT_PROFILE.UNBLOCK_CLIENT_BOOKING.UNBLOCKED_SUCCESS')
            .subscribe((translations: any) => {
              this.toastMessageService.showSuccess(translations);
            });
          this.btnLoading = false;
          this.closeDialogEvent('unblocked');
          this.cd.detectChanges();
        },
        error: (error) => {
          this.btnLoading = false;
          this.toastMessageService.showError(error);
          this.cd.detectChanges();
        },
      });
  }
}
